/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_Q2Inputs */

const en_minifier_faq_q2 = /** @type {(inputs: Minifier_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does minifying change my JSON data?`)
};

const ko_minifier_faq_q2 = /** @type {(inputs: Minifier_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축하면 JSON 데이터가 변경되나요?`)
};

const ja_minifier_faq_q2 = /** @type {(inputs: Minifier_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮するとJSONデータは変わりますか？`)
};

/**
* | output |
* | --- |
* | "Does minifying change my JSON data?" |
*
* @param {Minifier_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_q2 = /** @type {((inputs?: Minifier_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_q2(inputs)
	if (locale === "ko") return ko_minifier_faq_q2(inputs)
	return ja_minifier_faq_q2(inputs)
});